import { useRouter } from "next/router";
import { Page as Component } from "~/components/specifics/deals/index/Page";
import useItandiAccount from "~/hooks/useItandiAccount";

export function Page() {
	const router = useRouter();
	const { data: session } = useItandiAccount().currentAccount();
	if (session === null || !router.isReady) {
		return <></>;
	}
	return <Component session={session} />;
}
